<template>
  <div id="App">
    <router-view v-if="isRoouterAlive"></router-view>
  </div>
  <!-- 东莞市国际技术转移中心（以下简称：转移中心）是由东莞市政府授牌，依托清华大学的国际资源整合能力，委托东莞深圳清华大学研究院创新中心，联合其他企事业单位组建的综合科技服务平台，其使命是围绕东莞产业发展需求，带动我市相关科研机构及企业开展国际技术转移工作，推动一批跨国技术转移服务机构聚集东莞，吸引大量国际先进技术、人才和项目落户东莞，推动东莞成为面向世界、辐射全国的国际技术转移枢纽。
转移中心紧跟国家“一带一路”、“粤港澳大湾区建设”、东莞市“倍增计划”等重大战略规划，在现有海外驻点平台（美国硅谷、俄罗斯、拉丁美洲、以色列等）的基础上，进一步构建完善的国际资源网络，为海内外创新创业项目提供从项目引进、股权投资，产业对接、落地服务、培育集群等全链条服务，开展多渠道、宽领域、全方位的国际技术转移工作。
转移中心拥有一支专业化高素质的国际技术转移队伍，在技术判断，市场分析，项目对接与执行，投融资上有丰富的运作经验。中心团队致力于探索出符合东莞地情和中国国情的技术转移路径，为东莞地区的科技产业的迭代倍增做出应有的贡献。
我们正在东城区东宝路的智荟谷产业园内匠心打造1万平方米的科技项目孵化基地，将包含技术推介、商务洽谈、多功能展厅、项目孵化及加速空间等功能区域。基地紧邻东城万达广场等重要商圈，地理位置优越，配套齐全。转移中心将提供优质的国内外资源对接及专业的产学研科技配套服务，营造活跃的创新创业氛围，建立一个具有良好生态环境的国际技术转移中心。
 -->
 <!-- <meta name="renderer" content="webkit"> -->
</template>

<script>
export default {
  name: 'App',
  provide (){
    return {
      reload:this.reload
    }
  },
  data(){
    return{
      isRoouterAlive:true
    }
  },mounted () {
    // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    //   beforeRouteLeave(to, from, next){

    //   }

    //   window.addEventListener('hashchange', () => {
    //       let currentPath = window.location.hash.slice(1)
    //       console.log("--------------------")
    //       console.log("currentPath--------"+currentPath)
    //       console.log("this.$route.path----------"+this.$route.path)
    //       console.log("--------------------")
    //       if (this.$route.path !== currentPath) {
    //           this.$router.push(currentPath);// 主动更改路由界面
    //       }
    //   }, false);
    // }
    // history.pushState(null, null, document.URL);
    // window.addEventListener('popstate', function () {
    //   history.pushState(null, null, document.URL);
    // });

    // if (window.history && window.history.pushState) {
    //     window.addEventListener('popstate', function () {
    //         window.history.pushState('forward', null, '');
    //         window.history.forward(1);
    //     });
    // }
    // //
    // window.history.pushState('forward', null, '');
    // window.history.forward(1);
  },
  methods:{
    reload(){
      this.isRoouterAlive = false
      this.$nextTick(function(){
        this.isRoouterAlive = true
      })
    }
  }
}
</script>

<style>
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,form,fieldset,input,textarea,p,blockquote,th,td,input,button{margin:0;padding:0;}
a{text-decoration:none;}
table{border-collapse:collapse;border-spacing:0;}
ol,ul,li{list-style:none;}
body{font-family: Microsoft Yahei;color: #2a2a2a;}
img{border:none;}
button{cursor:pointer;}
input::-ms-clear{display:none;}

</style>
